import { FC, useCallback } from "react";
import { DeleteDimensionConfirmationDialog } from "../actions/DeleteDimensionConfirmationDialog";
import {
  ActionsMenu,
  ActionsMenuConfirmationDialogProps,
} from "../../common/ActionsMenu";
import { generateDimensionCategoriesFromCategoriesWithCosts } from "../../../../utils/helpers/generateDimensionCategoriesFromCategoriesWithCosts";
import { useAppDispatch } from "@/store/hooks";
import { setDimensionsState } from "@/store/dimensions/dimensionsSlice";
import { DimensionsWithChildren } from "@/store/dimensions/utils/types/common";

interface DimensionActionsCellRendererProps {
  data: DimensionsWithChildren;
}

export const DimensionActionsCellRenderer: FC<
  DimensionActionsCellRendererProps
> = ({ data }) => {
  const dispatch = useAppDispatch();

  const editDialogOpenHandler = useCallback(() => {
    if (!data) {
      return;
    }

    dispatch(
      setDimensionsState({
        drawerMode: "dimensionEdit",
        dimensionId: data.id,
        dimensionName: data.name,
        categories: generateDimensionCategoriesFromCategoriesWithCosts(
          data.categories,
        ),
        sharedCosts: [],
      }),
    );
  }, [dispatch, data]);

  const ConfirmationDialog = useCallback(
    ({ open, onClose }: ActionsMenuConfirmationDialogProps) => {
      if (!data) {
        return;
      }

      return (
        <DeleteDimensionConfirmationDialog
          name={data.name}
          open={open}
          dimensionId={data.id}
          categories={data.categories}
          onClose={onClose}
          onDelete={onClose}
        />
      );
    },
    [data],
  );

  if (!data) {
    return;
  }

  return (
    <ActionsMenu
      onEditOpen={editDialogOpenHandler}
      ConfirmationDialog={ConfirmationDialog}
    />
  );
};
